import Cookies from 'js-cookie'

import {
  AD_SERVER_TRACKING_URLS_COOKIE_PREFIX,
  AD_SERVER_TRACKING_URLS_DATA_ATTR,
} from 'shared/consts/adServer'
import store, { subscribe } from 'shared/store'
import { INIT_CROSSSELL } from 'shared/store/ducks/events'
import {
  type ClientCookieOptions,
  getTargetingKeywordsFromSearchParams,
  isAdServerEnabled,
} from 'shared/utils/adServerUtils'
import {
  AdServerDecisionEventId,
  type AdServerDecisionResponseEvent,
} from 'types/adServerTypes'
import {
  attachViewEvent,
  handleCloseAdBanner,
  initAdServer,
} from 'views/utils/adServerUtils'

const triggerViewUrl = () => {
  const slots = document.querySelectorAll<HTMLElement>('[data-tracking-events]')

  slots.forEach(slot => {
    const events: Array<AdServerDecisionResponseEvent> = JSON.parse(
      slot.getAttribute('data-tracking-events') || '[]'
    )

    events.forEach((event: AdServerDecisionResponseEvent) => {
      if (event.id === AdServerDecisionEventId.visible) {
        attachViewEvent(event.url, slot)
      }
    })
  })
}

const setTrackingUrlsToCookie = (selector: string) => {
  const element = document.querySelector(selector)
  let cookieValue: string | null
  let wid: string | null
  let moreLink: Element | null

  if (element) {
    cookieValue = element.getAttribute(AD_SERVER_TRACKING_URLS_DATA_ATTR)
    wid = element.getAttribute('data-crosssell-id')
    moreLink = element.querySelector(
      '[data-clientside-hook~="adServerSliderMoreLink"]'
    )

    if (cookieValue && moreLink && wid) {
      const {
        publicConfig: { mountPoints },
      } = store.getPublicRuntimeConfig()
      const cookieOptions: ClientCookieOptions = {
        // 30 mins
        expires: 30 / 1440,
        path: mountPoints.SEARCH as string,
        httpOnly: false,
      }

      moreLink.addEventListener('click', () => {
        if (cookieValue != null) {
          Cookies.withConverter<never>({
            write: (value: string) => value,
          }).set(
            `${AD_SERVER_TRACKING_URLS_COOKIE_PREFIX}${wid}`,
            cookieValue,
            cookieOptions
          )
        }
      })
    }
  }
}

export default () => {
  const {
    pageProperties: { experiments },
  } = store.getPublicRuntimeConfig() || {}

  if (isAdServerEnabled(experiments)) {
    const keywords = window._targetingKeywords || []

    window._targetingKeywords = [
      ...keywords,
      ...getTargetingKeywordsFromSearchParams(window.location.search),
    ]

    // @ts-ignore
    subscribe.after.once(INIT_CROSSSELL, payload => {
      const { selector } = payload

      setTrackingUrlsToCookie(selector)
      triggerViewUrl()
    })
    triggerViewUrl()

    initAdServer()

    handleCloseAdBanner()
  }
}
